
import { Component, Vue, Prop } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { Stocks } from '@/store/depot/types';
import { Asset } from '@/store/trading/types';
import { currency } from '@/filters/currency';
import { dateString } from '@/filters/date';
import ExporoTable from '@/components/_common/Table.vue';

@Component({
  name: 'stocks-list',
  filters: {
    currency,
    dateString,
  },
  components: {
    ExporoTable,
  },
})
export default class StocksOverviewCard extends Vue {
  @Prop({ default: undefined, required: true }) stocks?: Stocks;
  @Prop({ default: undefined, required: true }) isLoading?: Boolean;

  @Getter('trading/projects') projects?: Asset[];

  get tradingEnabled(): boolean {
    return process.env.VUE_APP_TRADING_ENABLED === 'true';
  }

  get tableData(): Array<object> {

    const tableData: Array<object> = [];

    if (this.stocks && this.stocks.data) {
      this.stocks.data
        .map(stock => {
          const row: { [key: string]: object } = {
            [ this.$t('transactionsList.dataTable.label', { context: 'project' }) ]: {
              text: stock.asset,
            },
            [ this.$t('transactionsList.dataTable.label', { context: 'isin' }) ]: {
              text: stock.wpNr,
            },
            [ this.$t('transactionsList.dataTable.label', { context: 'amount' }) ]: {
              text: this.parseAmount(stock.nwm),
            },
            [ this.$t('transactionsList.dataTable.label', { context: 'reporting' }) ]: {
              text: this.getProjectDetailPage(stock.wpNr),
            },
          };

          if (this.tradingEnabled) {
            row[ this.$t('transactionsList.dataTable.label', { context: 'action' }) as string ] = {
              text: '',
              value: stock.wpNr,
              slotId: `bonds-${stock.wpNr}`,
            };
          }

          tableData.push(row);
        });
    }

    return tableData;
  }

  parseAmount(amount) {
    return this.$options.filters.currency(amount);
  }

  onTableUpdate(val) {
    this.$emit('update', val);
  }

  canSellProject(assetId: string) {
    return !!this.projects?.find((asset) => {
      return asset.asset_id === assetId && asset.active === true && asset.tradable_on_exporo === true;
    });
  }

  getFinancialProductByStockId(assetId) {
    const asset = this.projects?.find(asset => asset.asset_id === assetId);

    return !!asset ? asset : null;
  }

  getProjectDetailPage(pdpId){
    const fp = this.getFinancialProductByStockId(pdpId);

    // change of the logic require by task ASANA-1210589887826797
    // change the link "Details" for each Yield Project to link to the matching "show quarterly reports" of the project.
    let link = '';
    if (!fp || fp.active === false) {
      link = `<a href="/depot/documents#projektupdates" style="text-decoration: underline; color: inherit;">
            ${this.$t('transactionsList.dataTable.label', { context: 'details' })}
          </a>`;
    }

    if (fp.tradable_on_exporo === true) {
      const fpId = fp.financial_product_id;
      link = `<a style="text-decoration: underline; color: inherit;" href="${process.env.VUE_APP_EXPORO_PDP_URL}/${fpId}/reporting" target="_blank">
            ${this.$t('transactionsList.dataTable.label', { context: 'details' })}
        </a>`;
    }

    return link;
  }
}
